/**
 * URL helpers for focused booking UX: hide cross-sells after a clear product choice.
 */

export const BOOKING_FLOW_SLOT = 'slot';
export const BOOKING_FOCUSED_PARAM = 'focused';

export function slotBookingUrl({ segment, pricingId, code } = {}) {
  const p = new URLSearchParams();
  p.set('flow', BOOKING_FLOW_SLOT);
  if (pricingId != null && pricingId !== '') {
    p.set('pricingId', String(pricingId));
  } else if (segment === 'sightseeing' || segment === 'intercity') {
    p.set('segment', segment);
  }
  if (code) p.set('code', String(code));
  return `/booking?${p.toString()}`;
}

export const BOOKING_HUB_URL = '/booking';

export function voucherPurchaseUrl({ focused } = {}) {
  if (focused) {
    return `/booking/voucher?${BOOKING_FOCUSED_PARAM}=1`;
  }
  return '/booking/voucher';
}

export function travelCompanionUrl({
  focused,
  date,
  date_from,
  date_to,
  flight_type: flightType,
  destination
} = {}) {
  const p = new URLSearchParams();
  if (focused) p.set(BOOKING_FOCUSED_PARAM, '1');
  if (date) p.set('date', date);
  if (date_from) p.set('date_from', date_from);
  if (date_to) p.set('date_to', date_to);
  if (flightType) p.set('flight_type', flightType);
  if (destination) p.set('destination', destination);
  const q = p.toString();
  return q ? `/booking/companions?${q}` : '/booking/companions';
}
